var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"class-information-success"},[_c('h3',[_vm._v("恭喜您完成入学报到"),_c('br'),_vm._v("记得添加班主任领取入学资料哦~")])])}]

export { render, staticRenderFns }